module.exports = __webpack_public_path__ + "img/icon-3.6a6b240d.svg";